import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-shopify-identity-redirect',
  templateUrl: './help-shopify-identity-redirect.component.html',
  styleUrls: ['./help-shopify-identity-redirect.component.scss']
})
export class HelpShopifyIdentityRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
